import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { navigationData, navigationDataAdmin } from '@constants/navigation.constant';
import { Navigation } from '@models/navigation.model';
import {
    BreacdcrumService,
    Breadcrumb,
} from '@core/services/breacdcrum.service';
import { IUserLocal, Level } from '@core/api-types/user';
import { LocalStorageService, LOCAL_STORAGE_KEY } from '@core/services/localstorage.service';

@Component({
    selector: 'dense-layout',
    templateUrl: './dense.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dense.scss'],
})
export class DenseLayoutComponent implements OnInit, OnDestroy {
    navigation: Navigation = navigationData;
    isScreenSmall: boolean;
    navigationAppearance: 'default' | 'dense' = 'dense';
    breadcrumbs$: Observable<Breadcrumb[]> = new Observable();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    user: IUserLocal = null;

    /**
     * Constructor
     */
    constructor(
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _breadCrumService: BreacdcrumService,
        private localStorageService: LocalStorageService
    ) {
        this.user = this.localStorageService.getObject(LOCAL_STORAGE_KEY.USER);
        this.breadcrumbs$ = this._breadCrumService.breadcrumbs$;
        this.navigation =
            this.user.Level === Level.ADMIN
                ? navigationDataAdmin
                : navigationData;
        // this.breadcrumbs$.subscribe(v => console.log(v))
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');

                // Change the navigation appearance
                this.navigationAppearance = this.isScreenSmall
                    ? 'default'
                    : 'dense';
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    /**
     * Toggle the navigation appearance
     */
    toggleNavigationAppearance(): void {
        this.navigationAppearance =
            this.navigationAppearance === 'default' ? 'dense' : 'default';
    }
}
